import React, {Component, ErrorInfo, ReactNode} from 'react';
import {View, Text, StyleSheet, Platform} from 'react-native';

import T from '../Components/T';
interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      errorInfo: null,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // @ts-ignore
      const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production');
      return (
        <View style={styles.container}>
          <Text style={styles.title}><T>Something went wrong</T></Text>
          <Text style={styles.message}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </Text>
          {isDev && this.state.errorInfo && (
            <Text style={styles.stack}>
              {this.state.errorInfo.componentStack}
            </Text>
          )}
          {isDev && this.state.error && (
            <Text style={styles.stack}>{this.state.error.stack}</Text>
          )}
          {!isDev && (
            <Text style={styles.message}>
              <T>Please check the browser console for more details.</T>
            </Text>
          )}
        </View>
      );
    }

    return this.props.children;
  }
}

const styles = StyleSheet.create({
  // @ts-ignore
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    backgroundColor: '#fff',
    ...(Platform.OS === 'web' && {
      minHeight: '100vh',
    }),
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#FF2171',
    marginBottom: 10,
  },
  message: {
    fontSize: 16,
    color: '#333',
    textAlign: 'center',
    marginBottom: 20,
  },
  stack: {
    fontSize: 12,
    color: '#666',
    fontFamily: Platform.OS === 'web' ? 'monospace' : 'monospace',
    marginTop: 10,
    padding: 10,
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    maxWidth: '90%',
  },
});

export default ErrorBoundary;


